import { APIGetMyMaps, APIUpdateMapPlans } from '../maps/Maps';
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports';
import { getHeaders } from "../utils";

Amplify.configure(awsconfig);


export async function APIGetMyPlans(companyId) {
    const token = await Auth.currentSession()
    const accessToken = token.getIdToken().getJwtToken();
    const authToken = `Bearer ${accessToken}`;
    try {
        if (companyId === undefined) {
            return null;
        }

        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN, authToken);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
                : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/plan/1.0/company/${companyId}/plans/all`,requestOptions);
        const responseObject = await response.json();
        const plans = responseObject?.data;

        if (plans.length > 0) {
            return plans.map(a => ({ ...a, hidden: false }));
        } else {
            return [];
        }
    } catch (error) {
        //console.error('Error:', error);
        //throw error;
    }
}

export const APIGetPlanDetails = async (planId, companyId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        const apiUrl = process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
                : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/plan/1.0/company/${companyId}/plans/single/${planId}`, requestOptions);
        const responseObject = await response.json();
        const plan = responseObject?.data;
        if (!plan) {
            throw new Error('Plan not found');
        }
        return plan;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIGetPlan = async (planId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        const apiUrl = process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;


        const response = await fetch(`${apiUrl}/rest/private/1.1/customer/plan/${planId}`, requestOptions);
        const responseObject = await response.json();
        const plan = responseObject?.data;

        const data = await fetch(plan.downloadUrl);
        const planJson = await data.json();

        return {plan, planJson};

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIGetPlanByLinkAccessId = async (linkAccessId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        const apiUrl = process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;

        const response = await fetch(`${apiUrl}/rest/public/customer/plan/1.0/${linkAccessId}`, requestOptions);
        const responseObject = await response.json();
        const plan = responseObject?.data;

        const data = await fetch(plan.downloadUrl);
        const planJson = await data.json();

        return {plan, planJson};

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIGetPlanByCredentialsAccessId = async (linkAccessId, username, password) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        const apiUrl = process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.1/customer/securedplan/${linkAccessId}?username=${username}&password=${password}`, requestOptions);
        const responseObject = await response.json();
        const plan = responseObject?.data;

        const data = await fetch(plan.downloadUrl);
        const planJson = await data.json();

        return {plan, planJson};

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIGetOrderPlan = async ({orderId,companyId,version, fileId, fileName}) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;

        const url = `${apiUrl}/rest/private/1.1/customer/plans/${companyId}/${orderId}/${version}/${fileId}/${fileName}`

        const response = await fetch(url, requestOptions);

        const responseText = await response.json();

        const plan = responseText.data;

        const data = await fetch(plan.downloadUrl);
        const planJson = await data.json();

        plan.name = planJson?.label;
        plan.type = planJson?.type;
        plan.planId = planJson?.planId;
        return {plan, planJson};

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIGetOpenDataPlan(openDataPlanId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/public/1.0/openData/plans/${openDataPlanId}/geojson`, requestOptions);
        const responseText = await response.json();
        var plan = {};
            plan.data = responseText.data;

        return plan;

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIGetPlanIntegration(accessId, planId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/public/1.0/integration/maps/${accessId}/${planId}`, requestOptions);
        const responseText = await response.json();

        const plan = responseText.data;
        const data = await fetch(plan.downloadUrl);
        const planJson = await data.json();

        plan.name = planJson?.label;
        plan.type = planJson?.type;
        plan.planId = planJson?.planId;

        return {plan, planJson};

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIDeletePlan(id, companyId) {
    const myMaps = await APIGetMyMaps(companyId);
    // check if plan is used in one of my maps
    if (myMaps) {
        for (const map of myMaps) {
            if (!map.plans || map.plans.length === 0) {
                continue;
            }
            if (map.plans.includes(id)) {
                const newPlans = map.plans.filter((item) => item !== id);
                await APIUpdateMapPlans(newPlans, map.id, companyId);
            }
        }
    }

    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'DELETE',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.1/customer/plan/${id}/${companyId}`, requestOptions);
        const responseObject = await response.json();
        const plan = responseObject?.data;
        return plan;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APICreatePlan = async (planId, user, company_id) => {
    try {
        const companyId = company_id ? company_id : user?.companyId;
        const userId = user?.id;

        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                planId,
                userId,
                companyId,
            }),
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;

        const fetchUrl = `${apiUrl}/rest/private/1.1/customer/plan`;
        await fetch(fetchUrl, requestOptions);

        return true;

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APICreateMultiplePlans = async (ids, user) => {
    for (const id of ids) {
        await APICreatePlan(id, user);
    }
}


export const APIGetPlanRefUrl = async (planId, filename) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.1/customer/planRef/${planId}?file=${filename}`, requestOptions);
        const responseObject = await response.json();
        const downloadUrl = responseObject?.data;

        if (!downloadUrl) {
            return null
        } 
        return downloadUrl;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIGetDownloadPlanUrl = async (planId) => {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
                ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION
                : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.1/customer/planUrl/${planId}`, requestOptions);
        const responseObject = await response.json();
        const downloadUrl = responseObject?.data;

        if (!downloadUrl) {
            return null
        } 
        return downloadUrl;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}